import { render, staticRenderFns } from "./PositionInfoMobile.vue?vue&type=template&id=3e68d4df&"
import script from "./PositionInfoMobile.vue?vue&type=script&lang=js&"
export * from "./PositionInfoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports